module.exports = __webpack_public_path__ + "7d2216446892476fcfa0e5d242f711df.png";